export default __webpack_public_path__ + "images/Image12.64b641a1.png";